import React from 'react'
import { Divider, makeStyles } from '@material-ui/core'
import { useSnackbar } from '@seasonedsoftware/ui'
import { useCroods } from 'croods'
import { email, presence } from 'forms/validations'
import { colors } from 'theme'
import { useForm } from 'utils/hooks'
import FormInput from 'ui/FormInput'
import SubmitButton from 'forms/SubmitButton'
import useCurrentUser from 'auth/useCurrentUser'
import { useHasSubscriberPrivilege } from 'utils/useUserType'
import { TITLE_SUGGESTED } from 'amplitude/events'
import useLogEventToAll from 'utils/useLogEventToAll'
import GetNotifiedText from './GetNotifiedText'

const SuggestTitleForm = ({ setShowRequestFormContent }) => {
  const { error } = useSnackbar()
  const classes = useStyles()
  const [{ currentUser }] = useCurrentUser()
  const subscribed = useHasSubscriberPrivilege()
  const log = useLogEventToAll()

  const [{ saving }, { save }] = useCroods({
    name: 'bookSuggestions',
    path: '/book_suggestions',
    afterSuccess: () => {
      setShowRequestFormContent(false)
    },
    afterFailure: () => {
      error('Something went wrong. Please try again')
    },
  })
  const { formState, fields, hasErrors } = useForm()

  const handleSubmit = event => {
    event && event.preventDefault && event.preventDefault()

    const values = {
      ...formState.values,
      email: subscribed ? currentUser.email : formState.values.email,
    }

    save({ method: 'POST' })(values)
    log(TITLE_SUGGESTED, {
      Title: values.title,
      Author: values.author,
      Email: values.email,
      Source: 'Modal',
    })
  }

  return (
    <form id="suggest-title-form" onSubmit={handleSubmit}>
      <FormInput
        label="Title"
        placeholder="Enter the Title's Name"
        variant="outlined"
        {...fields('text', 'title', [presence()])}
        roundedLevel="md"
        floatLabel
      />
      <FormInput
        label="Author"
        placeholder="Enter the Title's Author"
        variant="outlined"
        {...fields('text', 'author', [presence()])}
        roundedLevel="md"
        floatLabel
      />
      <Divider />

      <GetNotifiedText subscribed={subscribed} />
      {!subscribed && (
        <FormInput
          label="Email"
          placeholder="Enter your email"
          variant="outlined"
          {...fields('email', 'email', [presence(), email()])}
          roundedLevel="md"
          hiddenLabel
        />
      )}
      <SubmitButton
        form="suggest-title-form"
        role="button"
        variant="contained"
        loading={saving}
        disabled={hasErrors}
        className={classes.suggestTitleButton}
      >
        Request Study Guide
      </SubmitButton>
    </form>
  )
}

const useStyles = makeStyles(theme => ({
  suggestTitleButton: {
    width: '100%',
    marginBottom: theme.spacing(5),
    backgroundColor: colors.navyblue,
    borderRadius: '8px',
    padding: theme.spacing(1),
    color: colors.white,
  },
}))

export default SuggestTitleForm
